interface TrajectoryPoint { x: number; y: number; t: number }

/** Continuous visual orientation over the existing authoritative point list.
 * Position, launch/contact time and velocity/spin physics are never rewritten.
 */
export function projectileHeading(points: readonly TrajectoryPoint[], time: number): number {
  if (points.length < 2) return 0;
  let low = 0, high = points.length - 1;
  while (low < high) {
    const middle = Math.ceil((low + high) / 2);
    if (points[middle].t <= time) low = middle; else high = middle - 1;
  }
  const next = Math.min(low + 1, points.length - 1);
  const tangent = (index: number) => {
    const before = points[Math.max(0, index - 1)], after = points[Math.min(points.length - 1, index + 1)];
    let dx = after.x - before.x, dy = after.y - before.y;
    if (!dx && !dy) {
      // A held/repeated source point has no direction. Use the first nearby
      // nonzero chord rather than introducing a one-frame rotation to zero.
      for (let radius = 1; radius < points.length && !dx && !dy; radius++) {
        const a = points[Math.max(0, index - radius)], b = points[Math.min(points.length - 1, index + radius)];
        dx = b.x - a.x; dy = b.y - a.y;
      }
    }
    return Math.atan2(dy, dx);
  };
  const from = tangent(low), to = tangent(next), delta = Math.atan2(Math.sin(to - from), Math.cos(to - from));
  const duration = points[next].t - points[low].t;
  const fraction = duration > 0 ? Math.max(0, Math.min(1, (time - points[low].t) / duration)) : 0;
  return from + delta * fraction;
}
